const r = (e) => e.replace(/\D/g, "");
export {
  r as removeNonDigits
};
